import "whatwg-fetch";

import { performPasskeyAuthentication, toPasskeyLoginError } from "../../functions/passkeys";
import { fetchAccessToken, getUserId } from "../../functions/auth";
import { fetchUser, login } from "./user";
import { loginFailure, doingLoginRequest } from "./login";

/**
 * Initiates a passkey login flow.
 *
 * 1. Runs the WebAuthn authentication ceremony (options -> assertion -> verify)
 * 2. On success, fetches the access token and dispatches login
 *
 * @param {Object} [params] Optional parameters.
 * @param {string} [params.turnstileToken] Cloudflare Turnstile verification token.
 *
 * @returns {Function} A thunk action.
 */
export function passkeyLoginRequest( { turnstileToken } = {} ) {
	return async( dispatch ) => {
		dispatch( doingLoginRequest() );
		try {
			await performPasskeyAuthentication( { turnstileToken } );

			const token = await fetchAccessToken();
			dispatch( login( token, getUserId() ) );
			dispatch( fetchUser( getUserId() ) );
		} catch ( error ) {
			dispatch( loginFailure( toPasskeyLoginError( error ) ) );
		}
	};
}
